export default __webpack_public_path__ + "static/media/mask-group-1@3x.af294f10.png";